/*
 * GradesGrid Messages
 *
 * This contains all the text for the GradesGrid component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.grades.GradesGrid';

export default defineMessages({
  numberOfPoints: {
    id: `${scope}.numberOfPoints`,
    defaultMessage: '{num, number}{num, plural, one {pt} other {pts}}',
  },
});
